import React,{useState,useEffect} from 'react';
import {Grid,Paper} from '@material-ui/core';
// import FAQQuestion from '../faq/FAQQuestion';
import { Row, Col, Container, Card } from 'reactstrap';
import EirAccordionTile from '../eir-two-column-accordion/EirAccordionTile';
import "./eirBusinessAccordion.scss";
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import EirButton from '../eir-button/EirButton';
import { htmlWidget } from '../../Constants';

function EirBusinessAccordion(props){

    const renderContent = (content) => {
        return { __html: content };
    }

    const [bottomCTA] = React.useState(props.BottomCTA);
    const [stylingCTA] = React.useState({
        backgroundColor: props.BottomCTABackgroundColor,
        color: props.BottomCTAFontColor,
        borderColor: props.BottomCTAOutlineColor,
        hover: {
            backgroundColor: props.BottomCTABackgroundHoverColor,
            color: props.BottomCTAFontHoverColor,
            borderColor: props.BottomCTAOutlineHoverColor,
        }
    })

    //Top & bottom margins requirements for LB
    let marginDesktop, marginMobile;
    switch (props.MarginDT) {
        case ("Top-60px,Bot-0px"): {
            marginDesktop = " marginT-60 ";
            break;
        }
        case ("Top-0px,Bot-60px"): {
            marginDesktop = " marginB-60 ";
            break;
        }
        case ("Top-60px,Bot-60px"): {
            marginDesktop = " margin-60 ";
            break;
        }
        case ("Top-0px,Bot-0px"): {
            marginDesktop = " margin-0-D ";
            break;
        }
        default: {
            marginDesktop = "";
            break;
        }
    }
    switch (props.MarginMobile) {
        case ("Top-40px,Bot-0px"): {
            marginMobile = " marginT-40 ";
            break;
        }
        case ("Top-0px,Bot-40px"): {
            marginMobile = " marginB-40 ";
            break;
        }
        case ("Top-40px,Bot-40px"): {
            marginMobile = " margin-40 ";
            break;
        }
        case ("Top-0px,Bot-0px"): {
            marginMobile = " margin-0-M ";
            break;
        }
        default: {
            marginMobile = "";
            break;
        }
    }

    
        
    let BottomCTAprops = (bottomCTA != undefined ? ({
        text : bottomCTA.text, 
        title : bottomCTA.title, 
        link : bottomCTA.link, 
        target: bottomCTA.target, 
        type : bottomCTA.type, 
        icon : bottomCTA.icon,
        buttonStyle : bottomCTA.buttonStyle, 
        buttonSize : bottomCTA.buttonSize,
        theme : bottomCTA.theme,
        videoModal : bottomCTA.VideoModal,
        styling : stylingCTA

    }) : {});

    const cmsValues = {
        title : props.title!==undefined ? props.title : "",
        rightList : props.rightListItem!==undefined ? props.rightListItem :[],
        leftList : props.leftListItem!==undefined ? props.leftListItem :[],
        occurence : props.occurence
    }

    const marginTop = isMobile ? marginMobile : marginDesktop;

    return(
        <div id={"businessAccordian-"+cmsValues.occurence} className={`business-accordion-container ${marginTop}`}>

            {/* Module title */}
            {cmsValues.title !== "" && <div className={`accordion-main-title container ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(cmsValues.title)}></div>}

            {/* Accordion grid layout*/}
            <Grid container spacing={30} md={12} className="business-accordion-columns">

                {/* left column of accordion */}
                <Grid item sm={6} xs={12} className="business-accordion-columns-items" >
                    {/* {console.log("dummy",dummyData)} */}
                    {cmsValues.leftList.map((element,index)=> {
                         return(

                            (element.title!=="" && element.description!=="") ? 
                            <EirAccordionTile
                                key={index}
                                className="business-accordion-columns-item"
                                id={index}
                                index1={0}
                                index2={index}
                                Heading={element.title}
                                Copy={element.description}
                            /> : ""
                        );
                    })}
                </Grid>
                
                {/* right column of accordion */}
                {cmsValues.rightList.length > 0 && 
                <Grid item sm={6} xs={12} className="business-accordion-columns-items" >
                
                    {cmsValues.rightList.map((element,index)=> {
                         return(
                            (element.title!=="" && element.description!=="") ? 
                            <EirAccordionTile
                                key={index}
                                className="business-accordion-columns-item"
                                id={index}
                                index1={1}
                                index2={index}
                                Heading={element.title}
                                Copy={element.description}
                            /> : ""   
                        );
                    })}
                </Grid>
                }
            </Grid>
            <Container className="productTileBottomCTA-lb">
                    <EirButton {...BottomCTAprops} justifyContent= "justify-content-center">
                    </EirButton>
            </Container>
        </div>
    )
}

export default EirBusinessAccordion;